<template>
    <div class="PlaceMarkInput">
        <div class="title">
            <strong>{{titleName}}</strong>
            <span class="exit" v-on:click="close">X</span>
        </div>
        <!--{{placeMarkData.position}}-->
        <div class="PlaceMarkInfo">
            <div class="gray_border round_s scollbarY">
                <!--<h4 class="th_line_w btn_t"><span class="o_arrow m_1"></span><a>New PlaceMark Information</a></h4>-->
                <ul class="r_list">
                    <input class="fill_text box_size round_s" type="text" placeholder="Input PlaceMark Name" v-model="placeMarkInfo.name">
                </ul>
                <ul class="r_list">
                    <!--<select class="selectpicker">
                        <option>Mustard</option>
                        <option>Ketchup</option>
                        <option>Relish</option>
                    </select>-->

                    <div class="select box_size round_s select_box" style="width:100%;margin-left:auto;margin-right:auto;">
                        <p>Select PlaceMark Type</p>
                        <ul>
                            <li data-value="default" class="selected">Select Layer Type</li>
                            <li data-value="bus" class="">Bus</li>
                            <li data-value="food" class="">Food</li>
                            <li data-value="hospital" class="">Hospital</li>
                            <li data-value="railway" class="">Railway</li>
                            <li data-value="scenic" class="">Scenic</li>
                            <li data-value="station" class="">Station</li>
                            <li data-value="supermarket" class="">Supermarket</li>
                        </ul>
                    </div>
                </ul>
                <ul class="r_list">
                    <textarea class="fill_textarea round_s box_size" placeholder="Input PlaceMark Description !" v-model="placeMarkInfo.description"></textarea>
                </ul>
                <!--<ul class="r_list">
                    <div class="input-group mb-3">
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" id="inputGroupFile02">
                        <label class="custom-file-label" for="inputGroupFile02">Choose file</label>
                    </div>
                    <div class="input-group-append">
                        <span class="input-group-text" id="">Upload</span>
                    </div>
                    </div>
                </ul>-->
                
                <ul class="r_list">
                    <div style="float:left;width:80%">
                        <input class="round_s fill_text box_size" placeholder="Upload | enter a valid pictures | videos " v-model="placeMarkInfo.vedios" type="text">
                    </div>					
                    <div style="float:right;width:19%" class="btnupload">
                        <span class="round_s fill_btn_load blue_btn">Upload</span>
                        <form id="myupload" class="uploadbtn" :action="uploadUri" method="post" enctype="multipart/form-data">
                            <input id="balloon_fileupload" name="mypic" type="file">
                        </form>
                    </div>
                    <div style="clear:both"></div>
                </ul>
                <ul class="r_list">
                    <!--<div class="" style="width:80%;top:-20px;">-->
                        <div class="customProgress">
                            <span class="bar"></span>
                            <!--<span class="percent">0%</span>-->
                            <div style="clear:both"></div>
                        </div>
                        <div class="files"></div>
                        <div style="clear:both"></div>
                    <!--</div>-->
                </ul>
                
                <!--<ul class="r_list">
                    <input class="fill_text box_size round_s" type="text" v-bind:value="getCoordinateString()">
                </ul>-->
                <ul class="r_list_position" v-bind:class="{active:showposition}" >
                    <label for="longitude">longitude</label>
                    <span class="span_input"><input id="lon" class="fill_text box_size round_s" type="text" v-model="placeMarkInfo.coordinate.longitude"></span>
                    <label for="latitude">latitude</label>
                    <span class="span_input"><input id="lat" class="fill_text box_size round_s" type="text" v-model="placeMarkInfo.coordinate.latitude"></span>
                    <label for="height">height</label>
                    <span class="span_input"><input id="height" class="fill_text box_size round_s" type="text" v-model="placeMarkInfo.coordinate.height"></span>
                    
                </ul>
            </div>
            <div class="r_d_btn btn_layer cf2"> 
                <span class="l w_5">
                    <input type="button" class="round_s fill_btn_r blue_btn_b" value="SAVE" v-on:click="createPlaceMark">
                </span> 
                <span class="r w_5">
                    <input type="button" class="round_s fill_btn_r gray_btn_g" value="CANCEL" v-on:click="close">
                </span> 
            </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'PlaceMarkInput',
    props: [
      'placeMarkData',
      'showposition'
    ],
    data () {
      return {
        titleName: 'Input PlaceMark Information',
        msg: 'This is PlaceMark Input!',
        uploadUri: undefined,
        placeMarkInfo: {
            name: undefined,
            coordinate: {},
            type: "default",
            description: undefined,
            vedios: undefined
        },
        placeMarkType:[],
        // placeMarkCoordinate: undefined,
        // selectedPlaceMarkType: "",
      }
    },
    mounted: function() {
        var placeMarkTypeMap = pfAirViewer._dataSave._placeMarkImage;
        //var objectToStream = new Cesium.ObjectToStream();
        //vue test
        placeMarkTypeMap['default'] = "./static/images/placeMark/placemark.png";
        placeMarkTypeMap['bus'] = "./static/images/placeMark/placemarkbusT.png";
        placeMarkTypeMap['food'] = "./static/images/placeMark/placemarkfoodT.png";
        placeMarkTypeMap['hospital'] = "./static/images/placeMark/placemarkhospitalT.png";
        placeMarkTypeMap['railway'] = "./static/images/placeMark/placemarkrailwayT.png";
        placeMarkTypeMap['scenic'] = "./static/images/placeMark/placemarkscenicT.png";
        placeMarkTypeMap['station'] = "./static/images/placeMark/placemarkstationT.png";
        placeMarkTypeMap['supermarket'] = "./static/images/placeMark/placemarksupermarketT.png";

        this.uploadUri = pfAirViewer._dataSave._baseUri+"action/upload";
        //$('.selectpicker').selectpicker();
        // this.createDrawTool("draw_option");
        
        var that = this;
        $('.select > p').on('click', function (e) {
            $(this).parent('.select').toggleClass('open');
            e.stopPropagation();
        });
        $('.select > ul li').on('click', function (e) {
            var _this = $(this);
            $(this).parent().siblings('p').text(_this.attr('data-value'));
            that.placeMarkInfo.type = _this.attr('data-value');
            _this.addClass('selected').siblings().removeClass('selected');
            $('.select').removeClass('open');
            e.stopPropagation();
        });
        if(Cesium.defined(this.placeMarkData.position))
        {
            this.placeMarkInfo.coordinate = Cesium.Cartographic.fromCartesian(this.placeMarkData.position);
        }
        
        /*$("#balloon_fileupload").change(function(){
            alert("Submitted");
            $("#myupload").submit(function(e){
                alert("good");
            });
        });*/
        $("#balloon_fileupload").change(function(){
            $("#myupload").ajaxSubmit({
                dataType:  'json',
                beforeSend: function() {
                    $(".customProgress").show();
                    var percentVal = '0%';
                    $('.bar').width(percentVal);
                    $('.percent').html(percentVal);
                    $(".btn span").html("uploading...");
                },
                uploadProgress: function(event, position, total, percentComplete) {
                    var percentVal = percentComplete + '%';
                    $('.bar').width(percentVal);
                    $('.percent').html(percentVal);
                },
                success: function(data) {
                    $(".files").html("<b>("+data.size+"k)</b>");
                    //$("#balloon_mediaInfo").val(data.name);
                    that.placeMarkInfo.vedios = data.name;
                    // var img = "./files/"+data.pic;
                    $(".btn span").html("UpLoad");
                    $('.percent').html("100% OK");
                },
                error:function(xhr){
                    $(".btn span").html("UpLoad Fail");
                    $('.bar').width('0')
                    $(".files").html(xhr.responseText);
                    alert(xhr.responseText);
                }
            });
        });
        if(this.showposition){
            this.initCoordinate(this.placeMarkData.position);
        }
        
    },
    methods: {
        close: function() {
            this.$emit('closeDialog','');
        },
        createPlaceMark: function() {
            if(this.placeMarkInfo.description == undefined){
                alert("description is empty!");
                return;
            }

            if(this.showposition){
                var new_lon = Number(this.placeMarkInfo.coordinate.longitude);
                var new_lat = Number(this.placeMarkInfo.coordinate.latitude);
                var new_height = Number(this.placeMarkInfo.coordinate.height);
                if(new_lon < -180 || new_lon > 180){
                alert('longitude out of range');
                return;
                }
                if(new_lat < -90 || new_lat > 90){
                alert('latitude out of range');
                return;
                }
                var new_point=new Cesium.Cartesian3();
                Cesium.Cartesian3.fromDegrees(new_lon,new_lat,new_height,Cesium.Ellipsoid.WGS84,new_point);
                this.placeMarkInfo.coordinate = new_point;
            }
            //modify coordinate
            
            this.$emit('savePlaceMark',this.placeMarkInfo);
        },
        getLontitude: function () {
            if (this.placeMarkInfo.coordinate) {
                var longitude=Cesium.Math.toDegrees(this.placeMarkInfo.coordinate.longitude);
                return longitude.toFixed(5);
            }
        },
        getLatitude: function () {
            if (this.placeMarkInfo.coordinate) {
                var latitude=Cesium.Math.toDegrees(this.placeMarkInfo.coordinate.latitude);
                return latitude.toFixed(5);
            }
        },
        getHeight: function () {
            if (this.placeMarkInfo.coordinate) {
                return this.placeMarkInfo.coordinate.height.toFixed(5);
            }
        },
        initCoordinate: function(positionCartesian3){
            var tempCart = Cesium.Cartographic.fromCartesian(this.placeMarkData.position);
            this.placeMarkInfo.coordinate.longitude = Cesium.Math.toDegrees(tempCart.longitude).toFixed(5);
            this.placeMarkInfo.coordinate.latitude = Cesium.Math.toDegrees(tempCart.latitude).toFixed(5);
            this.placeMarkInfo.coordinate.height = tempCart.height.toFixed(5);
        },
        getCoordinateString: function() {
            if(this.placeMarkInfo.coordinate)
            {
                return this.placeMarkInfo.coordinate.longitude.toFixed(5)+" | "+this.placeMarkInfo.coordinate.latitude.toFixed(5)+" | "+this.placeMarkInfo.coordinate.height.toFixed(2);
            }
        }
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
    margin: 0;
    padding: 0;
    /*overflow:hidden;*/
}
.PlaceMarkInput {
    position: fixed;
    z-index: 10000;
    border-radius: 5px;
    height: 60%;
    min-height: 574px;
    left: 35%;
    top: 20%;
    width: 30%;
    background: #f3f3f3 none repeat scroll 0 0;
    box-shadow: 10px 10px 30px #888888 ;
    border: medium none;
    padding: 0;
}
.title {
    background-color: #12285f;
    border: medium none;
    border-radius: 3px 3px 0 0;
    clear: both;
    color: #fff;
    height: 44px;
    line-height: 44px;
    overflow: hidden;
}
.title strong {
    display: block;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    text-transform: uppercase;
}
.title .exit {
    background: rgba(0, 0, 0, 0) url('../../static/Cesium/Assets/AirEarth/images/close_w.png') no-repeat scroll center center;
    border: medium none;
    cursor: pointer;
    display: block;
    height: 40px;
    line-height: 40px;
    position: absolute;
    right: 0;
    text-align: center;
    text-indent: -99999px;
    top: 0;
    width: 40px;
}

.PlaceMarkInfo {
    padding: 1em 1em 1em;
    height: 530px;
}
.gray_border {
    background: #fff none repeat scroll 0 0;
    border: 1px solid #cecece;
    margin-bottom: 1em;
    /*height: 78%;*/
}
.th_line_w {
    border-bottom: 1px solid #cecece;
    font-size: 14px;
    font-weight: normal;
    height: 44px;
    line-height: 22px;
    padding: 9px 0;
}
.o_arrow {
  background-image: url("../../static/images/icon/arrow.png");
  background-repeat: no-repeat;
  float: left;
  height: 22px;
  margin-right: 0.2em;
  margin-left: 30px;
  overflow: hidden;
  width: 22px;
}
.box_size {
    box-sizing: border-box;
}
/*
upload css
*/
.customProgress {
  border-radius: 1px;
  display: none;
  padding: 0;
  /*position: absolute;*/
  width: 80%;
  float: left;
}
.bar {
	/*position:absolute;*/
	background-color: green;
	display:block;
	width:80%;
	height:20px;
	border-radius: 3px;
}
.percent {
  color: #fff;
  /*display: inline-block;*/
  height: 10px;
  left: 2%;
  float: left;
  position: relative;
  top: 3px;
}
.btnupload {
    background-color: #0d5881;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    overflow: hidden;
    padding: 1px;
    height: 38px;
    text-align: center;
    vertical-align: middle;
}
.btnupload input {
    border: medium solid transparent;
    cursor: pointer;
    display: inline-block;
    margin: 0;
    opacity: 0;
    right: 0;
    top: -10px;
}
.fill_btn_load {
    border: medium none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 30px;
    vertical-align: top;
    width: 18%;
}
.uploadbtn {
    top: -32px;
    position: relative;
}
.files{
	/*position: absolute;*/
    float: left;
	/*right: 10px;
	height:20px;*/
    padding-left: 5px;
    padding-right: 2px;
	line-height:20px;
	margin:1px 0
}

textarea {
  resize: none;
}
.gray_border ul .t {
  margin-top: 0.8em;
}
.fill_text {
  background-color: #f3f3f3;
  border: 1px solid #e0e0e0;
  height: 38px;
  line-height: 32px;
  padding: 5px 5%;
  width: 100%;
}

.fill_textarea {
  background-color: #f3f3f3;
  border: 1px solid #e0e0e0;
  height: 38px;
  line-height: 32px;
  padding: 5px 5%;
  width: 100%;
}

.fill_text:focus, .fill_textarea:focus {
  background-color: #fff;
  border-color: #09aaf3;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
}
.fill_textarea {
  height: 120px;
  overflow: visible;
}

.span_input {
  display: block;
  overflow: hidden;
  padding: 4px 0 4px 0;

}

label{
    text-align: center;
    float: left;
    clear: both;
    margin-right: 5px;
    margin-top: 5px;
    line-height: 32px;
    width: 80px;
}

.r_list {
    font-size: 14px;
    margin: 0.5em 1em;
}


.r_list_position{
    display: none;
}

.r_list_position.active{
    display: block;
    font-size: 14px;
    margin: 0.5em 1em;
}

ul {
  list-style: outside none none;
}
input {
    color: black;
}
a {
    text-decoration: none;
}
.select {
  background-color: #f3f3f3;
  background-image: url("../../static/images/icon/option.png");
  background-position: 95% center;
  background-repeat: no-repeat;
  border: 1px solid #e0e0e0;
  height: 32px;
  position: relative;
  text-align: left;
  width: 100%;
}
.select_box {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  height: 42px;
  line-height: 42px;
  color: black;
}
.select ul {
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  height: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 20px;
  transition: height 0.3s ease-out 0s, top 0.3s ease-out 0s;
  width: 100%;
  z-index: 1;
}
.select.open ul {
  height: 150px;
  overflow-y: auto;
  top: -80px;
  transition: all 0.2s ease-in 0s;
}
.select.open ul li:nth-child(1) {
  transition: opacity 0.3s ease-in 0.05s, transform 0.3s ease-in 0.05s;
}
.select.open ul li {
  opacity: 1;
  transform: translateX(0px);
}
.select ul li {
  cursor: pointer;
  line-height: 30px;
  opacity: 0;
  padding: 0 15px;
  transform: translateX(300px);
  transition: transform 0.3s ease-out 0s;
}
.select ul li.selected {
  color: #0d5881;
}
.r_list li {
  margin: 0.6em 0;
}

.r_list_position li{
  margin: 0.6em 0;
}

.select_box p {
  height: 42px;
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
}
.select p {
  cursor: pointer;
  line-height: 32px;
  padding: 0.3em 1em;
}
.cf {
    overflow: hidden;
}
.cf2::after {
    clear: both;
    content: "";
    display: block;
    height: 0;
}
.l {
    float: left;
}
.r {
    float: right;
}
.w_5 {
    width: 48%;
}
.round_s, .round_s_img img {
    border-radius: 3px;
}
.blue_btn, .blue_btn_b:hover {
    background-color: #0d5881;
}
.blue_btn:hover, .blue_btn_b {
    background-color: #12285f;
}
.red_btn {
    background-color: #bf5442;
}
.red_btn:hover {
    background-color: #ac2b15;
}
.gray_btn, .gray_btn_g:hover {
    background-color: #c5c5c5;
}
.gray_btn:hover {
    background-color: #999;
}
.gray_btn_g {
    background-color: #e0e0e0;
    color: #555;
}
.fill_btn_r {
    border: medium none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    vertical-align: top;
    width: 100%;
}
.btnupload {
    background-color: #0d5881;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    margin-right: 4px;
    overflow: hidden;
    padding: 1px;
    height: 38px;
    text-align: center;
    vertical-align: middle;
}
.btnupload input {
    border: medium solid transparent;
    cursor: pointer;
    display: inline-block;
    margin: 0;
    opacity: 0;
    right: 0;
    top: -10px;
}
.fill_btn_load {
    border: medium none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 30px;
    vertical-align: top;
    width: 18%;
}
.uploadbtn {
    top: -32px;
    position: relative;
}

</style>


// WEBPACK FOOTER //
// src/components/PlaceMarkInput.vue